module.exports = __webpack_public_path__ + "img/meguru01.ac003f12.png";